export enum TypeActions {
  SELECTED_IDS = 'SELECTED_IDS',
}

export type Actions = { type: TypeActions.SELECTED_IDS; payload: string[] }
